import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Login from './Login';
import SignUp from './SignUp';

import "./Auth.css"

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';
const MAX_VERIFY_RETRIES = 3;   // リトライ回数
const RETRY_INTERVAL_MS = 1500; // リトライ間隔 (ms)

function Auth(props) {
  const [isLoginScreen, setIsLoginScreen] = useState(props.isLogin);
  const navigate = useNavigate();

  /**
   * Cookieが反映されているか確認する関数
   *  - 失敗した場合、指定回数リトライ
   */
  const verifyCookie = async (attempt = 1) => {
    try {
      const res = await axios.get(`${API_BASE}/api/auth/verify`, {
        withCredentials: true, // Cookieを送る
      });
      // 成功したらログ表示して /tasks へ遷移
      console.info('verifyCookie success:', res.data);
      navigate('/tasks');
    } catch (err) {
      console.warn(`verifyCookie attempt #${attempt} failed:`, err);

      if (attempt < MAX_VERIFY_RETRIES) {
        // リトライ
        setTimeout(() => {
          verifyCookie(attempt + 1);
        }, RETRY_INTERVAL_MS);
      } else {
        // リトライ上限超え → エラー表示
        console.error('認証が確認できませんでした。再度ログインしてください。');
      }
    }
  };

  /**
   * ログイン処理を行う関数
   * @param {string} email - ユーザーのメールアドレス
   * @param {string} password - ユーザーのパスワード
   * @param {function} failureCallback - 失敗時のコールバック関数
   */
  const handleLogin = (email, password, failureCallback) => {
    console.info(`Attempting to log in user: ${email}`);
    axios.post(`${API_BASE}/api/auth/login`, {
      email: email,
      password: password
    }, {
      withCredentials: true, // クッキーを含めるために必要
    }).then((res) => {
      // ログインレスポンス成功 → Cookieセットされたはず
      console.info(`User logged in successfully: ${email}, Now verifying...`);
      // verifyCookieでCookie反映を確認
      verifyCookie();
    }).catch((error) => {
      if (error.response) {
        // サーバーがステータスコードで応答
        console.error(`Login failed for ${email}: ${error.response.status} - ${error.response.data.message || error.response.data.error}`);
      } else if (error.request) {
        // リクエストが送信されたが応答がない
        console.error(`No response received during login attempt for ${email}:`, error.request);
      } else {
        // エラーの設定中に発生
        console.error(`Error during login attempt for ${email}:`, error.message);
      }
      failureCallback(error);
    });
  };

  /**
   * サインアップ処理を行う関数
   * @param {string} displayName - ユーザーの表示名
   * @param {string} email - ユーザーのメールアドレス
   * @param {string} password - ユーザーのパスワード
   * @param {function} failureCallback - 失敗時のコールバック関数
   */
  const handleSignUp = (displayName, email, password, failureCallback) => {
    console.info(`Attempting to sign up user: ${email}`);
    axios.post(`${API_BASE}/api/auth/signup`, {
      displayName: displayName,
      email: email,
      password: password,
    }, {
      withCredentials: true, // クッキーを含めるために必要
    }).then((res) => {
      console.info(`User signed up successfully: ${email}`);
      navigate('/login');
    }).catch((error) => {
      if (error.response) {
        // サーバーがステータスコードで応答
        console.error(`Sign up failed for ${email}: ${error.response.status} - ${error.response.data.message || error.response.data.error}`);
      } else if (error.request) {
        // リクエストが送信されたが応答がない
        console.error(`No response received during sign up attempt for ${email}:`, error.request);
      } else {
        // エラーの設定中に発生
        console.error(`Error during sign up attempt for ${email}:`, error.message);
      }
      failureCallback(error);
    });
  };

  /**
   * サインアップ画面に切り替える関数
   */
  const switchToSignUp = () => {
    console.info('Switching to Sign Up screen');
    setIsLoginScreen(false);
  };

  /**
   * ログイン画面に切り替える関数
   */
  const switchToLogin = () => {
    console.info('Switching to Login screen');
    setIsLoginScreen(true);
  };

  return (
    <>
      {/* 認証画面 */}
      {isLoginScreen ? (
        <Login
          onLogin={handleLogin}
          switchToSignUp={switchToSignUp}
        />
      ) : (
        <SignUp
          onSignUp={handleSignUp}
          switchToLogin={switchToLogin}
        />
      )}
    </>
  );
}

export default Auth;
